import {
  useMutation,
  useQueryClient,
  type UseMutationOptions,
} from "@tanstack/react-query";

import { toast } from "@/shared/hooks/use-toast";

import { templatesApi } from "../api";
import { templateKeys } from "./template.keys";

export function useDeleteTemplate(
  options?: UseMutationOptions<void, Error, string>,
) {
  const queryClient = useQueryClient();
  const { onSuccess: providedOnSuccess, onError: providedOnError, ...rest } = options ?? {};
  const mutation = useMutation({
    mutationKey: [...templateKeys.all, "delete"],
    mutationFn: templatesApi.remove,
    ...rest,
    onSuccess: (_, id, ctx) => {
      toast({ title: "Template excluído", variant: "success" });
      queryClient.invalidateQueries({ queryKey: templateKeys.all });
      (providedOnSuccess as any)?.(_, id, ctx);
    },
    onError: (error, vars, ctx) => {
      toast({
        title: "Erro ao excluir template",
        description: error.message,
        variant: "destructive",
      });
      (providedOnError as any)?.(error, vars, ctx);
    },
  });
  return {
    deleteTemplate: (id: string) => mutation.mutateAsync(id),
    isLoading: mutation.isPending,
    error: mutation.error,
    reset: mutation.reset,
    mutationResult: mutation,
  };
}
